// Test IDs for the shop, cart, checkout, account and content pages.
export const SHOP = {
  page: 'shop-page',
  cardRating: (slug) => `shop-card-rating-${slug}`,
  topRated: (slug) => `shop-top-rated-${slug}`,
  topRatedFilter: 'shop-top-rated-filter',
  topRatedEmpty: 'shop-top-rated-empty',
  categoryPill: (id) => `shop-category-${id}`,
  searchInput: 'shop-search-input',
  productCard: (slug) => `shop-product-card-${slug}`,
  kiddeeSeal: (slug) => `shop-kiddee-seal-${slug}`,
  cardPrice: (slug) => `shop-card-price-${slug}`,
  addButton: (slug) => `shop-add-to-cart-${slug}`,
  favButton: (slug) => `shop-favorite-${slug}`,
  empty: 'shop-empty-state',
};

export const PRODUCT = {
  page: 'product-page',
  stickyBar: 'product-mobile-sticky-bar',
  name: 'product-name',
  price: 'product-price',
  qtyInput: 'product-qty-input',
  qtyMinus: 'product-qty-minus',
  qtyPlus: 'product-qty-plus',
  addButton: 'product-add-to-cart',
  favButton: 'product-favorite-button',
  notFound: 'product-not-found',
  verdict: 'product-kiddee-verdict',
  spec: (k) => `product-spec-${k}`,
  mainImage: 'product-main-image',
  thumb: (i) => `product-thumb-${i}`,
  details: 'product-details',
  related: 'product-related',
  backToKiddee: 'product-back-to-kiddee',
  kiddeeSeal: 'product-kiddee-seal',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  orderId: 'contact-order-id',
  message: 'contact-message',
  submit: 'contact-submit',
  success: 'contact-success',
  another: 'contact-send-another',
};

export const REVIEW = {
  page: 'review-page',
  invalid: 'review-invalid',
  item: (slug) => `review-item-${slug}`,
  star: (slug, n) => `review-star-${slug}-${n}`,
  text: (slug) => `review-text-${slug}`,
  name: (slug) => `review-name-${slug}`,
  petName: (slug) => `review-pet-name-${slug}`,
  photo: (slug) => `review-photo-${slug}`,
  submit: (slug) => `review-submit-${slug}`,
  done: (slug) => `review-done-${slug}`,
  productSection: 'product-reviews',
  productAverage: 'product-reviews-average',
  topRated: 'product-top-rated',
  reply: (id) => `product-review-reply-${id}`,
  productReview: (id) => `product-review-${id}`,
};

export const CHAT = {
  launcher: 'kiddee-chat-launcher',
  panel: 'kiddee-chat-panel',
  close: 'kiddee-chat-close',
  reset: 'kiddee-chat-reset',
  messages: 'kiddee-chat-messages',
  input: 'kiddee-chat-input',
  send: 'kiddee-chat-send',
  typing: 'kiddee-chat-typing',
  starter: (i) => `kiddee-chat-starter-${i}`,
  product: (slug) => `kiddee-chat-product-${slug}`,
  productAdd: (slug) => `kiddee-chat-product-add-${slug}`,
  bundle: (slug) => `kiddee-chat-bundle-${slug}`,
  bundleAdd: (slug) => `kiddee-chat-bundle-add-${slug}`,
  bundlePrice: (slug) => `kiddee-chat-bundle-price-${slug}`,
};

export const CART = {
  navButton: 'nav-cart-button',
  navCount: 'nav-cart-count',
  page: 'cart-page',
  line: (slug) => `cart-line-${slug}`,
  minus: (slug) => `cart-qty-minus-${slug}`,
  plus: (slug) => `cart-qty-plus-${slug}`,
  remove: (slug) => `cart-remove-${slug}`,
  codeInput: 'cart-discount-input',
  codeApply: 'cart-discount-apply',
  codeError: 'cart-discount-error',
  subtotal: 'cart-subtotal',
  discount: 'cart-discount',
  shipping: 'cart-shipping',
  total: 'cart-total',
  emailInput: 'cart-email-input',
  emailNote: 'cart-email-note',
  checkout: 'cart-checkout-button',
  bundleSavings: 'cart-bundle-savings',
  stickyBar: 'cart-mobile-sticky-bar',
  nudge: (b) => `cart-bundle-nudge-${b}`,
  nudgeAdd: (b) => `cart-bundle-nudge-add-${b}`,
  codeSkipped: 'cart-code-skipped-note',
  empty: 'cart-empty-state',
};

export const PAYMENT = {
  success: 'payment-success-page',
  status: 'payment-status-text',
  orderId: 'payment-order-id',
  cancel: 'payment-cancel-page',
  follow: 'payment-follow-kiddee',
  followLink: (id) => `payment-follow-${id}`,
};

export const ACCOUNT = {
  navButton: 'nav-account-button',
  loginButton: 'account-login-button',
  logoutButton: 'account-logout-button',
  page: 'account-page',
  name: 'account-user-name',
  orders: 'account-orders-list',
  order: (id) => `account-order-${id}`,
  noOrders: 'account-no-orders',
  favorites: 'favorites-page',
  navFavorites: 'nav-favorites-button',
};

export const TRACK = {
  page: 'track-page',
  orderInput: 'track-order-input',
  emailInput: 'track-email-input',
  submit: 'track-submit-button',
  result: 'track-result',
  error: 'track-error',
};

export const SIGNUP = {
  emailInput: (src) => `signup-${src}-email-input`,
  phoneInput: (src) => `signup-${src}-phone-input`,
  submit: (src) => `signup-${src}-submit-button`,
  success: (src) => `signup-${src}-success`,
  guidePage: 'guide-page',
  guideTab: (v) => `guide-tab-${v}`,
};

export const COLLAB = {
  page: 'collab-page',
  name: 'collab-name-input',
  email: 'collab-email-input',
  handle: 'collab-handle-input',
  platform: 'collab-platform-select',
  followers: 'collab-followers-select',
  pet: 'collab-pet-select',
  submit: 'collab-submit-button',
  result: 'collab-result',
  code: 'collab-code',
  link: 'collab-link',
  error: 'collab-error',
  statsLink: 'collab-stats-link',
  statsPage: 'collab-stats-page',
  statsHandle: 'collab-stats-handle-input',
  statsEmail: 'collab-stats-email-input',
  statsSubmit: 'collab-stats-submit',
  statsResult: 'collab-stats-result',
  statsError: 'collab-stats-error',
  stat: (k) => `collab-stat-${k}`,
};

export const ADMIN = {
  page: 'admin-page',
  denied: 'admin-denied',
  tab: (t) => `admin-tab-${t}`,
  chatStats: 'admin-chat-stats',
  chatStat: (k) => `admin-chat-stat-${k}`,
  reviewsList: 'admin-reviews-list',
  reviewsEmpty: 'admin-reviews-empty',
  reviewRow: (id) => `admin-review-${id}`,
  reviewApprove: (id) => `admin-review-approve-${id}`,
  reviewHide: (id) => `admin-review-hide-${id}`,
  reviewDelete: (id) => `admin-review-delete-${id}`,
  reviewFilter: (s) => `admin-review-filter-${s}`,
  messagesList: 'admin-messages-list',
  messagesEmpty: 'admin-messages-empty',
  messageRow: (id) => `admin-message-${id}`,
  messageToggle: (id) => `admin-message-toggle-${id}`,
  messageReply: (id) => `admin-message-reply-${id}`,
  reviewReplyInput: (id) => `admin-review-reply-${id}`,
  reviewReplySuggest: (id) => `admin-review-reply-suggest-${id}`,
  reviewReplySave: (id) => `admin-review-reply-save-${id}`,
  productRow: (slug) => `admin-product-${slug}`,
  priceInput: (slug) => `admin-price-${slug}`,
  verdictInput: (slug) => `admin-verdict-${slug}`,
  activeToggle: (slug) => `admin-active-${slug}`,
  saveButton: (slug) => `admin-save-${slug}`,
  newName: 'admin-new-name',
  newPrice: 'admin-new-price',
  newImage: 'admin-new-image',
  newCategory: 'admin-new-category',
  newDescription: 'admin-new-description',
  newVerdict: 'admin-new-verdict',
  newSubmit: 'admin-new-submit',
  orderRow: (id) => `admin-order-${id}`,
  trackingInput: (id) => `admin-tracking-${id}`,
  shipButton: (id) => `admin-ship-${id}`,
  search: 'admin-product-search',
  detailsPanel: (slug) => `admin-details-${slug}`,
  detailsToggle: (slug) => `admin-details-toggle-${slug}`,
  specInput: (slug, k) => `admin-spec-${k}-${slug}`,
  costInput: (slug) => `admin-cost-${slug}`,
  shipCostInput: (slug) => `admin-ship-cost-${slug}`,
  marginPreview: (slug) => `admin-margin-${slug}`,
  galleryAdd: (slug) => `admin-gallery-add-${slug}`,
  galleryRemove: (slug, i) => `admin-gallery-remove-${slug}-${i}`,
  aiPhotoBadge: (slug) => `admin-ai-photo-${slug}`,
  photoFilter: 'admin-needs-photo-filter',
  labelCost: (id) => `admin-label-cost-${id}`,
  profit: 'admin-dash-profit',
  funnel: 'admin-dash-funnel',
  insightRow: (slug) => `admin-insight-${slug}`,
  clipUpload: 'admin-clip-upload',
  clipUploadInput: 'admin-clip-upload-input',
  clipRow: (id) => `admin-clip-row-${id}`,
  clipOrder: (id) => `admin-clip-order-${id}`,
  clipProduct: (id) => `admin-clip-product-${id}`,
  clipTitle: (id) => `admin-clip-title-${id}`,
  clipActive: (id) => `admin-clip-active-${id}`,
  clipSave: (id) => `admin-clip-save-${id}`,
  clipDelete: (id) => `admin-clip-delete-${id}`,
  clipStatus: (id) => `admin-clip-status-${id}`,
  rowPhoto: (slug) => `admin-photo-${slug}`,
  favToggle: (slug) => `admin-kiddee-fav-${slug}`,
  newPhoto: 'admin-new-photo',
  newFav: 'admin-new-kiddee-fav',
  dashboard: 'admin-dashboard',
  dashTotal: (k) => `admin-dash-total-${k}`,
  dashBar: (d) => `admin-dash-bar-${d}`,
  bestSeller: (slug) => `admin-best-seller-${slug}`,
  topCreator: (h) => `admin-top-creator-${h}`,
  lowMargin: 'admin-low-margin',
  marginThreshold: 'admin-margin-threshold',
  marginSave: 'admin-margin-save',
  lowMarginRow: (slug) => `admin-low-margin-${slug}`,
  lowMarginBadge: (slug) => `admin-low-margin-badge-${slug}`,
  lowMarginFilter: 'admin-low-margin-filter',
  aiWrite: (slug) => `admin-ai-write-${slug}`,
  aiStop: (slug) => `admin-ai-stop-${slug}`,
  descriptionInput: (slug) => `admin-description-${slug}`,
  aiVerdict: (slug) => `admin-ai-verdict-${slug}`,
  draftsRun: 'admin-drafts-run',
  draftsProgress: 'admin-drafts-progress',
  draftsEmpty: 'admin-drafts-empty',
  draftsApproveAll: 'admin-drafts-approve-all',
  draftRow: (slug) => `admin-draft-${slug}`,
  draftText: (slug) => `admin-draft-text-${slug}`,
  draftApprove: (slug) => `admin-draft-approve-${slug}`,
  draftDiscard: (slug) => `admin-draft-discard-${slug}`,
  chatsList: 'admin-chats-list',
  chatsEmpty: 'admin-chats-empty',
  chatSession: (id) => `admin-chat-${id}`,
};

export const BUNDLES = {
  section: 'kiddee-bundles-section',
  card: (slug) => `bundle-card-${slug}`,
  price: (slug) => `bundle-price-${slug}`,
  fullPrice: (slug) => `bundle-full-price-${slug}`,
  add: (slug) => `bundle-add-${slug}`,
};

export const ADMIN_EXTRA = {
  bundlesList: 'admin-bundles-list',
  bundleRow: (slug) => `admin-bundle-${slug}`,
  bundleName: (slug) => `admin-bundle-name-${slug}`,
  bundleTagline: (slug) => `admin-bundle-tagline-${slug}`,
  bundleItem: (slug, i) => `admin-bundle-item-${slug}-${i}`,
  bundleDiscount: (slug) => `admin-bundle-discount-${slug}`,
  bundleActive: (slug) => `admin-bundle-active-${slug}`,
  bundleSave: (slug) => `admin-bundle-save-${slug}`,
  bundleDelete: (slug) => `admin-bundle-delete-${slug}`,
  bundleAddItem: (slug) => `admin-bundle-add-item-${slug}`,
  bundleNew: 'admin-bundle-new',
  weekly: 'admin-weekly-report',
  weeklySales: 'admin-weekly-sales',
  weeklyOrders: 'admin-weekly-orders',
  weeklyAlerts: 'admin-weekly-margin-alerts',
  weeklyPreview: 'admin-weekly-preview-frame',
  weeklySend: 'admin-weekly-send-button',
  weeklyTo: 'admin-weekly-send-to',
  merchant: 'admin-merchant-setup',
  merchantDownload: (fmt) => `admin-merchant-download-${fmt}`,
  bundleStats: 'admin-bundle-stats',
  bundleStatsWeek: (w) => `admin-bundle-stats-week-${w}`,
  bundleStatsLift: 'admin-bundle-stats-lift',
  bundleStatsRow: (slug) => `admin-bundle-stats-row-${slug}`,
  liveCheck: 'admin-live-check',
  appStats: 'admin-app-stats',
  appStatsWeek: (w) => `admin-app-stats-week-${w}`,
  appStatsInstalls: 'admin-app-stats-installs',
  appStatsOpens: 'admin-app-stats-opens',
  appStatsOrders: 'admin-app-stats-orders',
  appStatsSales: 'admin-app-stats-sales',
  appStatsTotal: 'admin-app-stats-all-time',
  liveMode: 'admin-live-check-mode',
  liveStart: 'admin-live-check-start',
  liveStatus: 'admin-live-check-status',
  liveRefresh: 'admin-live-check-refresh',
  liveRefund: 'admin-live-check-refund',
  merchantCopy: (k) => `admin-merchant-copy-${k}`,
  merchantValue: (k) => `admin-merchant-value-${k}`,
};

export const KIDDEE_PAGE = {
  page: 'kiddee-collection-page',
  hero: 'kiddee-hero',
  title: 'kiddee-hero-title',
  heroCta: 'kiddee-hero-shop-button',
  heroVideo: 'kiddee-hero-video',
  heroVideoToggle: 'kiddee-hero-video-toggle',
  favorites: 'kiddee-favorites-section',
  favoritesGrid: 'kiddee-favorites-grid',
  playStyles: 'kiddee-play-styles',
  style: (id) => `kiddee-play-style-${id}`,
  clearStyle: 'kiddee-clear-style',
  toys: 'kiddee-toys-section',
  toysGrid: 'kiddee-toys-grid',
  story: 'kiddee-story-section',
  social: (id) => `kiddee-story-social-${id}`,
  faq: 'kiddee-faq-section',
  faqItem: (i) => `kiddee-faq-item-${i}`,
  policiesLink: 'kiddee-faq-policies-link',
  finalCta: 'kiddee-final-cta',
  finalShop: 'kiddee-final-shop-button',
  finalAll: 'kiddee-final-all-button',
};

export const INSTALL = {
  banner: 'install-app-banner',
  add: 'install-app-add',
  dismiss: 'install-app-dismiss',
  iosHelp: 'install-app-ios-help',
};

export const BLOG = {
  page: 'blog-page',
  post: 'blog-post-page',
  card: (slug) => `blog-card-${slug}`,
  product: (slug) => `blog-product-${slug}`,
  empty: 'blog-empty',
  back: 'blog-back-link',
  adminList: 'admin-blog-list',
  adminRow: (slug) => `admin-blog-row-${slug}`,
  adminEdit: (slug) => `admin-blog-edit-${slug}`,
  adminTitle: 'admin-blog-title',
  adminExcerpt: 'admin-blog-excerpt',
  adminBody: 'admin-blog-body',
  adminSave: 'admin-blog-save',
  adminPublish: 'admin-blog-publish-toggle',
  adminDelete: 'admin-blog-delete',
  adminNew: 'admin-blog-new',
  aiProduct: (i) => `admin-blog-ai-product-${i}`,
  aiAngle: 'admin-blog-ai-angle',
  aiDraft: 'admin-blog-ai-draft',
};
